var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEur = function SvgEur(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H0V14H16V2Z",
    fill: "#2E42A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20268 3.33333L8.46168 4.09727H9.29983L8.62172 4.56939L8.88072 5.33332L8.20268 4.86116L7.52451 5.33332L7.78358 4.56939L7.10547 4.09727H7.94361L8.20268 3.33333Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75957 4.69958L5.50644 5.06422L6.09909 4.49629L5.96793 5.2896L6.71474 5.65427L5.88693 5.77994L5.75581 6.5733L5.37529 5.85759L4.54749 5.98328L5.14014 5.41533L4.75957 4.69958Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 7.9997L4.13052 7.75146V6.94824L4.62314 7.5981L5.42031 7.34987L4.9276 7.9997L5.42031 8.6495L4.62314 8.4013L4.13052 9.05116V8.2479L3.33337 7.9997Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75957 11.2989L5.1401 10.5831L4.54749 10.0152L5.37532 10.1409L5.75578 9.42519L5.88693 10.2185L6.71474 10.3441L5.96799 10.7088L6.09909 11.5021L5.50644 10.9342L4.75957 11.2989Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20268 12.6667L7.94361 11.9028H7.10547L7.78358 11.4306L7.52451 10.6667L8.20268 11.1389L8.88072 10.6667L8.62172 11.4306L9.29983 11.9028H8.46168L8.20268 12.6667Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.646 11.2989L10.8992 10.9342L10.3065 11.5022L10.4377 10.7088L9.69092 10.3441L10.5187 10.2185L10.6498 9.42519L11.0303 10.1409L11.8581 10.0152L11.2655 10.5832L11.646 11.2989Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0724 7.9997L12.2753 8.2479V9.05116L11.7827 8.4013L10.9856 8.6495L11.4782 7.9997L10.9856 7.34987L11.7827 7.5981L12.2753 6.94824V7.75149L13.0724 7.9997Z",
    fill: "#FFDA44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.646 4.69955L11.2655 5.4153L11.8582 5.98325L11.0303 5.85753L10.6498 6.57325L10.5187 5.7799L9.69092 5.65422L10.4377 5.28958L10.3065 4.49629L10.8992 5.06422L11.646 4.69955Z",
    fill: "#FFDA44"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEur);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "EUR.0161bb3abf729e04a003dbdc62590c86.svg";